import { useQuery } from '@tanstack/react-query';
import { ApiEndpointEnum } from '@/enums/ApiEndpointEnum';
import type { Cart } from '@/types';
import useApiFetch from './useApiFetch';

export function useCartQuery() {
  const { get } = useApiFetch();
  return useQuery<Cart>({
    queryKey: ['cart'],
    queryFn: async ({ signal }) => {
      const data = await get(ApiEndpointEnum.GetCart, undefined, signal);
      const cart = (data as any)?.cart || data;
      return cart as Cart;
    },
  });
}
